import { render, staticRenderFns } from "./ModalService.vue?vue&type=template&id=00d3c70d&scoped=true&"
import script from "./ModalService.vue?vue&type=script&lang=js&"
export * from "./ModalService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d3c70d",
  null
  
)

export default component.exports